import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import StrengthsSection from './components/StrengthsSection';
import CropsSection from './components/CropsSection';
import LocationsSection from './components/LocationsSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

export default function ContractSpraying() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <StrengthsSection />
        <CropsSection />
        <LocationsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}